import type { FC } from 'react';

import type { Currency } from '@zen/types';

import FormCurrencySelect from '../FormCurrencySelect';
import type { FormFieldProps } from '../FormField';
import FormLabel from '../FormLabel';
import FormNumberInput from '../FormNumberInput';

interface Props extends FormFieldProps {
  availableCurrencies?: Currency[];
  className?: string;
  isDisabled?: boolean;
  step?: string;
}

const FormCurrencyInput: FC<Props> = (props) => {
  const { autoFocus, availableCurrencies, className, isDisabled, isRequired, label, name, step = '0.01' } = props;

  return (
    <div className={className}>
      <FormLabel label={label} name={`${name}.value`} />
      <div className="flex flex-row space-x-1 whitespace-nowrap">
        <FormNumberInput
          autoFocus={autoFocus}
          className="flex-1 min-w-20"
          disabled={isDisabled}
          hideLabel={true}
          isRequired={isRequired}
          min={0}
          name={`${name}.value`}
          placeholder="0.0"
          step={step}
        />
        <FormCurrencySelect
          availableCurrencies={availableCurrencies}
          hideLabel={true}
          isDisabled={isDisabled}
          isRequired={isRequired}
          name={`${name}.currency`}
          renderMenuInPortal={true}
        />
      </div>
    </div>
  );
};

export default FormCurrencyInput;
